// Popup pro Internet Explorer
var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
var trident = ua.indexOf('Trident/');
if(msie > 0 || trident > 0){
   alert("Internet Explorer není­ podporovaný prohlížeč. Aktualizujte prosím na modernější variantu, například Google Chrome, atd. Děkujeme za pochopení.");
};